import { render } from "./FormTransaction.vue?vue&type=template&id=5306da8b&ts=true"
import script from "./FormTransaction.vue?vue&type=script&lang=ts"
export * from "./FormTransaction.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__